import { useEffect, useState } from "react";
import { join, size } from "lodash";
import { getTotalDisplay } from "utils/getTotalDisplay";
import { AiccLanguageStatus } from "constants/aiccLanguage";
import { useLearningAssetsStore } from "../../useLearningAssetsStore";

const LESSON_ENTRY_PAGE_SIZE = 20;

export function useLessonEntryPagination(entries: unknown[], groupStatus?: AiccLanguageStatus, disabled = false) {
  const languageId = useLearningAssetsStore((state) => state.languageId);
  const selectedLevels = useLearningAssetsStore((state) => state.selectedLevels);
  const selectedLessons = useLearningAssetsStore((state) => state.selectedLessons);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(LESSON_ENTRY_PAGE_SIZE);

  const resetKey = join([languageId, groupStatus, selectedLevels, selectedLessons], "|");

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const lastPage = Math.max(1, Math.ceil(size(entries) / pageSize));

  useEffect(() => {
    if (page > lastPage) {
      setPage(lastPage);
    }
  }, [lastPage, page]);

  return {
    showTotal: getTotalDisplay,
    current: page,
    pageSize,
    showSizeChanger: true,
    disabled,
    onChange: (nextPage: number, nextPageSize?: number) => {
      setPage(nextPage);
      setPageSize(nextPageSize ?? LESSON_ENTRY_PAGE_SIZE);
    },
  };
}
